<div class="modal-body">
  <div class="modal-fluid">
    <div class="section-holder">
      <div class="container-fluid auth-container">
        <div class="">
      
          <div class="completed-header"> </div>
      
          <!-- Dailylog  -->
          <h2 class="confirm-labels" id="account-validated">
            {{ "questionnaire.questionnaire" | translate}}
          </h2>
      
          <div class="confirm-caption custom-m-md text-center">
            <p>
              {{ "questionnaire.setupDescription" | translate }}
              <p>
          </div>
      
          <div class="buttons-holder">
            <button mat-raised-button (click)="confirm()" color="primary"
              class="m-b-md mat-primary">
              <span class="capitalize"> {{ "questionnaire.createQuestionnaire" | translate }} </span>
            </button>
          </div>
      
        </div>
      </div>
    </div>
  </div>
</div>
